// Shared vehicle helpers used by the Fleet page and host profile filters.

// Clean "model" label: strip the leading year and the make from the name.
export function carModel(c) {
  let n = (c.name || "").trim();
  n = n.replace(/^\d{4}\s+/, "");
  const mk = (c.make || "").trim();
  if (mk && n.toLowerCase().startsWith(mk.toLowerCase())) n = n.slice(mk.length).trim();
  return n || c.name || "";
}

export function carPrice(c) {
  return c.rates?.daily_start || (c.weekly_rate ? c.weekly_rate / 7 : 0);
}

// Apply make/model/location filters + price sort to a list of cars.
export function filterAndSortCars(cars, { make = "All", model = "All", location = "All", sort = "price_asc" } = {}) {
  let list = [...cars];
  if (make !== "All") list = list.filter((c) => c.make === make);
  if (model !== "All") list = list.filter((c) => carModel(c) === model);
  if (location !== "All") list = list.filter((c) => (c.pickup_location || "") === location);
  if (sort === "price_asc") list.sort((a, b) => carPrice(a) - carPrice(b));
  else if (sort === "price_desc") list.sort((a, b) => carPrice(b) - carPrice(a));
  return list;
}
